(function () {
  'use strict';

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input, init) {
    var nextInput = input;

    try {
      var recommendationsPath = window.routes && window.routes.product_recommendations_url;
      var isSupportedInput = typeof input === 'string' || input instanceof URL;

      if (recommendationsPath && isSupportedInput) {
        var requestUrl = new URL(input, window.location.href);
        var recommendationsUrl = new URL(recommendationsPath, window.location.origin);

        if (
          requestUrl.origin === recommendationsUrl.origin &&
          requestUrl.pathname === recommendationsUrl.pathname
        ) {
          var pageUrl = new URL(window.location.href);

          ['country', 'currency'].forEach(function (key) {
            var value = pageUrl.searchParams.get(key);
            if (value && !requestUrl.searchParams.has(key)) {
              requestUrl.searchParams.set(key, value);
            }
          });

          nextInput = requestUrl.toString();
        }
      }
    } catch (error) {
      // Keep the original request when a URL cannot be parsed.
    }

    return nativeFetch.call(this, nextInput, init);
  };
})();
